import { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "../../services/auth";
import HeaderUI from "./HeaderUI";
import { useCart } from "../Cart/CartContext";

export default function Header({
  categories,
  onCategorySelect,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [search, setSearch] = useState("");
  const { isAuthenticated, user, logout } = useAuth();

  const { cartCount, fetchCartCount } = useCart();

  const currentTab = location.pathname.includes("profile") ? "profile" : "home";

  const normalize = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw.results)) return raw.results;
    if (Array.isArray(raw.data)) return raw.data;
    if (Array.isArray(raw.categories)) return raw.categories;
    if (Array.isArray(raw.meta?.categories)) return raw.meta.categories;
    return [];
  };
  const finalCategories = normalize(categories);

  useEffect(() => {
    const urlQuery = searchParams.get("search") || "";
    setSearch(urlQuery);
  }, [searchParams]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchCartCount();
    }
  }, [isAuthenticated, fetchCartCount]);

  const handleSearch = () => {
    const trimmed = search.trim();
    if (trimmed) {
      navigate(`/?search=${encodeURIComponent(trimmed)}&page=1`);
    } else {
      navigate("/");
    }
  };

  const handleClearSearch = () => {
    setSearch("");
    navigate("/");
  };


  const handleNavigation = (target) => {
    if (target === "profile") {
      if (isAuthenticated) {
        navigate("/profile");
      } else {
        navigate("/login", {
          state: { from: `${location.pathname}${location.search || ""}` || "/" },
        });
      }
      return;
    }
    if (target === "home") {
      navigate("/");
    }
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <HeaderUI
      search={search}
      setSearch={setSearch}
      handleSearch={handleSearch}
      handleClearSearch={handleClearSearch}
      tab={currentTab}
      handleNavigation={handleNavigation}
      isAuthenticated={isAuthenticated}
      user={user}
      cartCount={cartCount}
      categories={finalCategories}
      onSelectCategory={onCategorySelect}
      onLogout={handleLogout}
    />
  );
}
